<template>
  <li>
    <router-link :to="{ name: 'programs.edit', params: { id: program.id } }">
      <div class="row">
        <div class="col">
          <p class="strong">{{ program.name | nullable }}</p>
        </div>
        <div class="col-auto">
          <span v-if="programIsDraft" class="status status-default">Draft</span>
          <span v-else-if="programIsScheduled" class="status status-info">Scheduled</span>
          <span v-else-if="programIsActive" class="status status-success">Active</span>
          <span v-else-if="programIsComplete" class="status status-default">Complete</span>
          <span v-else-if="programIsArchived" class="status status-warning">Archived</span>
        </div>
      </div><!-- /.row -->
    </router-link>
  </li>
</template>

<script>
import { helpers } from 'mixins/programs'

export default {
  mixins: [helpers],

  props: {
    program: {
      required: true,
      type: Object
    }
  }
}
</script>
